import React, {useState, useEffect} from 'react'
import getColorOverride from '../../utilities/functions';
import Gainsbar from './GainsBar'

// const styles = makeStyles({
// 	gainsDiv: {
//         flex: (props)=> props.small ? 4 : 5,
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         position: 'relative',
//         justifyContent: 'center',
//         // boxSizing: 'border-box'
//     },
//     centerBar: {
//         position: 'absolute',
//         borderLeft: '1px solid black',
//         left: '50%',
//         height: '97%',
//         zIndex: 20
        
//     }
// })

const Gains = (props) => {
    const [max, setMax] = useState(1);

    useEffect(()=>{
        let tempMax = 0
        if (props.data) {
            props.data.partyResults.forEach(party=> {
                if (Math.abs(party.seatChange) > tempMax) {
                    tempMax = Math.abs(party.seatChange)
                }
            })
            setMax(tempMax)

        }

    },[props.data])

    return (
        <div className={'classes.gainsDiv flex-grow w-3/5 flex flex-col relative items-center justify-center'} >

            <div className={'classes.centerBar absolute h-full w-full z-10 self-center'} style={{background: 'linear-gradient(#000, #000) no-repeat center/2px 100%'}}/>
            {props.data && props.data.partyResults.map((party,i)=>{
                let override = getColorOverride(party.nameShort, props.election)
                let partyWidth = 0
                if (max !== 0) {
                    partyWidth = (party.seatChange)/(max) * 100;
                }
                if (props.data.partyResults.length > 6) {
                    if (i < 5) {
                    return <Gainsbar key={i} color={override ? override.color : party.color} small={props.small} width={`${partyWidth/2}`}/>
                } else if (i === props.data.partyResults.length -1) {
                    return <Gainsbar key={i} color={override ? override.color : party.color} small={props.small} width={`${partyWidth/2}`}/>
                }} 
                else {
                    return <Gainsbar key={i} color={override ? override.color : party.color} small={props.small} width={`${partyWidth/2}`}/>
                }
                
            })}
        </div>
    )
}

export default Gains